'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = require('react-router');

var _historyLibCreateBrowserHistory = require('history/lib/createBrowserHistory');

var _historyLibCreateBrowserHistory2 = _interopRequireDefault(_historyLibCreateBrowserHistory);

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var component = _react2['default'].createElement(
    _reactRouter.Router,
    { history: (0, _historyLibCreateBrowserHistory2['default'])() },
    _routes2['default']
);

_reactDom2['default'].render(component, document.getElementById('content'));


/** WEBPACK FOOTER **
 ** ./~/babel-loader!./source/index.jsx
 **/